<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<ng-container *ngIf="!(tableEditActive && isEditable)">
    <ng-container *ngIf="!fieldDefinition.type || fieldDefinition.type === 'string'">
        <dash-gis-string-field [fieldDefinition]="fieldDefinition" [rowData]="rowData"></dash-gis-string-field>
    </ng-container>
    <ng-container *ngIf="fieldDefinition.type && fieldDefinition.type === 'number'">
        <dash-gis-number-field [fieldDefinition]="fieldDefinition" [rowData]="rowData"></dash-gis-number-field>
    </ng-container>
    <ng-container *ngIf="fieldDefinition.type && fieldDefinition.type === 'date'">
        <dash-gis-date-field [fieldDefinition]="fieldDefinition" [rowData]="rowData"></dash-gis-date-field>
    </ng-container>
    <ng-container *ngIf="fieldDefinition.type && fieldDefinition.type === 'link'">
        <dash-gis-link-field [fieldDefinition]="fieldDefinition" [rowData]="rowData"></dash-gis-link-field>
    </ng-container>
    <ng-container *ngIf="fieldDefinition.type && fieldDefinition.type === 'report'">
        <dash-gis-reportlink-field [fieldDefinition]="fieldDefinition" [rowData]="rowData"></dash-gis-reportlink-field>
    </ng-container>
    <ng-container *ngIf="fieldDefinition.type && fieldDefinition.type === 'document'">
        <dash-gis-document-link-field [fieldDefinition]="fieldDefinition" [rowData]="rowData"></dash-gis-document-link-field>
    </ng-container>
    <ng-container *ngIf="fieldDefinition.type && fieldDefinition.type === 'video'">
        <dash-gis-video-field [fieldDefinition]="fieldDefinition" [rowData]="rowData"></dash-gis-video-field>
    </ng-container>
    <ng-container *ngIf="fieldDefinition.type && fieldDefinition.type === 'qrcode'">
        <dash-gis-qr-code-field [fieldDefinition]="fieldDefinition" [rowData]="rowData"></dash-gis-qr-code-field>
    </ng-container>
</ng-container>
<ng-container *ngIf="tableEditActive && isEditable" [formGroup]="dataFormGroup">

    <ng-container [ngSwitch]="dataFormField.uiType" [formGroupName]="rowData[dataForm.definition.dbKey]">

        <input *ngSwitchCase="'text'" class="inline-input" [formControlName]="fieldDefinition.name" />

        <ng-container *ngSwitchCase="'dropdown'">
            <ng-container *ngIf="dataForm">
                <dash-gis-table-dropdown [formControlName]="fieldDefinition.name"
                                   [options]="dataFormField.dropdownItems"></dash-gis-table-dropdown>
                <dash-gis-table-db-dropdown *ngIf="dataFormField.parameter"
                                      [formControlName]="fieldDefinition.name"
                                      [formName]="tableDataFormName"
                                      [parameterValue]="dropdownParameterValue"></dash-gis-table-db-dropdown>
            </ng-container>
        </ng-container>

    </ng-container>

</ng-container>

